import ActiveLink from "@/components/ActiveLink";
import ScrollMenu from "@/components/ScrollMenu";
import { useAuthUserQuery } from "@/hooks";
import routes from "@/lib/routes";
import styles from "@/styles/Header.module.scss";

function AuthorizedPrimaryNavigation({ loggedIn }) {
  if (!loggedIn) return null;
  return (
    <ScrollMenu className={styles.primaryNavigationInner}>
      <ActiveLink className={styles.menuContLink} href={routes.home}>
        <span>ホーム</span>
      </ActiveLink>

      <ActiveLink
        className={styles.menuContLink}
        href={routes.valuePlan}
        matchtype="partial"
      >
        <span>バリュープラン</span>
      </ActiveLink>

      <ActiveLink
        className={styles.menuContLink}
        href={routes.channels}
        matchtype="partial"
      >
        <span>月額商品</span>
      </ActiveLink>
      <ActiveLink
        className={styles.menuContLink}
        href={routes.store}
        matchtype="partial"
      >
        <span>単品商品</span>
      </ActiveLink>
      <ActiveLink
        className={styles.menuContLink}
        href={routes.myList}
        matchtype="partial"
      >
        <span>マイリスト</span>
      </ActiveLink>
    </ScrollMenu>
  );
}
function NotAuthorizedPrimaryNavigation({ loggedIn }) {
  if (loggedIn) return null;
  return (
    <ScrollMenu className={styles.primaryNavigationInner}>
      <ActiveLink className={styles.menuContLink} href={routes.home}>
        <span>ホーム</span>
      </ActiveLink>
      <ActiveLink
        className={`${styles.menuContLink} ${styles.valuePlanLink}`}
        href={routes.valuePlan}
        matchtype="partial"
      >
        <span>バリュープラン</span>
      </ActiveLink>
      <ActiveLink
        className={styles.menuContLink}
        href={routes.channels}
        matchtype="partial"
      >
        <span>月額商品</span>
      </ActiveLink>
      <ActiveLink
        className={styles.menuContLink}
        href={routes.store}
        matchtype="partial"
      >
        <span>単品商品</span>
      </ActiveLink>
    </ScrollMenu>
  );
}
// export default memo(PrimaryNavigation);
export default function PrimaryNavigation() {
  const { loading, data } = useAuthUserQuery({ fetchPolicy: "cache-first" });
  const loggedIn = !loading && data?.user;

  return (
    <div className={styles.primaryNavigation}>
      <NotAuthorizedPrimaryNavigation loggedIn={loggedIn} />
      <AuthorizedPrimaryNavigation loggedIn={loggedIn} />
    </div>
  );
}
